/**
 * Work Item Registry types (WQ-298 / ADR-019 D2) — match the Pydantic schemas
 * in work_item_router.py (`/api/admin/work-items`). Hand-tracked (no codegen);
 * update both when one changes.
 */

export type WorkItemLane = 'A_source_change' | 'B_runtime_op';

export type WorkItemStatus =
  | 'proposed'
  | 'approved'
  | 'in_progress'
  | 'blocked'
  | 'done'
  | 'rejected';

export type WorkItemSeverity = 'info' | 'low' | 'medium' | 'high' | 'critical';

export interface WorkItem {
  id: string;
  display_id: string | null; // REM-NNNN (NULL for operator-created)
  lane: WorkItemLane;
  title: string;
  body_markdown: string;
  status: WorkItemStatus;
  severity_token: WorkItemSeverity;
  originating_skill: string | null;
  originating_event_id: string | null;
  source_queue: string | null;
  external_ref: string | null;
  action_url: string | null;
  entity_type: string | null;
  entity_id: string | null;
  gate_decision_id: string | null;
  submitted_by_actor_id: string | null;
  assigned_to_actor_id: string | null;
  created_at: string | null;
  updated_at: string | null;
}

export interface WorkItemListResponse {
  items: WorkItem[];
  total: number;
  limit: number;
  offset: number;
}

export interface WorkItemFilters {
  lane?: WorkItemLane;
  status?: WorkItemStatus;
  severity_token?: WorkItemSeverity;
  originating_skill?: string;
  limit?: number;
  offset?: number;
}

export interface UpdateWorkItemBody {
  status?: WorkItemStatus;
  assigned_to_actor_id?: string;
}

export const WORK_ITEM_LANES: WorkItemLane[] = ['A_source_change', 'B_runtime_op'];
export const WORK_ITEM_STATUSES: WorkItemStatus[] = [
  'proposed', 'approved', 'in_progress', 'blocked', 'done', 'rejected',
];
export const WORK_ITEM_SEVERITIES: WorkItemSeverity[] = [
  'critical', 'high', 'medium', 'low', 'info',
];
